import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { theme, useResponsive } from '@sweetgreen/garnish';

export type AccountScreenSectionProps = ViewProps;

export const AccountScreenSection = (props: AccountScreenSectionProps) => {
  const { minWidth } = useResponsive();

  const sectionStyle = [
    styles.section,
    minWidth.tablet ? styles.sectionSM : {},
  ];

  return (
    <View
      testID={props.testID ?? 'account.screen-section'}
      style={[sectionStyle, props.style]}
    >
      {props.children}
    </View>
  );
};

const styles = StyleSheet.create({
  section: {
    flexGrow: 1,
  },
  sectionSM: {
    borderRadius: theme.radius.large,
    backgroundColor: theme.colors.OATMEAL,
    width: '100%',
    maxWidth: 664,
    marginBottom: theme.spacing.xlarge,
  },
});
